// extracted by mini-css-extract-plugin
export default {"students":"HeaderSection_students__lDx4+","aafterIcon":"HeaderSection_aafterIcon__wDM7U","text":"HeaderSection_text__k0bte","a":"HeaderSection_a__cXNOf"};